import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericConfirmModal from "../common/GenericConfirmModal";

interface IParams {
  screen: IScreenStatus;
}

const PersonalScreenRegenerateButton: React.FC<IParams> = ({ screen }) => {
  const rootStore = useContext(RootStoreContext);
  const { regeneratePersonalScreen } = rootStore.screensStore;
  const [isModalOpen, setisModalOpen] = useState(false);
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      <Button
        onClick={() => setisModalOpen(true)}
        className="screenRefreshButton mr-2 ml-auto "
      >
        <i className="fas fa-redo fa-4x screenQrIcon"></i>
        <h5 className="mb-0">{t("screens_personal_regenerate")}</h5>
      </Button>
      <GenericConfirmModal
        title={t("screens_personal_regenerate_modal_title")}
        isOpen={isModalOpen}
        toggle={() => setisModalOpen(!isModalOpen)}
        action={() => regeneratePersonalScreen()}
        messages={t("screens_personal_regenerate_confirm")}
      />
    </>
  );
};

export default observer(PersonalScreenRegenerateButton);
